import React, {useState} from 'react';
import PropTypes from 'prop-types';
import Spin from 'antd/lib/spin';
import PendingActionAlert from '../../../features/dashboard/components/PendingActionAlert';
import AllocationItem from './AllocationItem';
import SignAllocation from './SignAllocation';
import AllocationsFilter from './AllocationsFilter';
import { Button, Icon } from 'antd';
// import { use } from 'i18next/dist/commonjs';

const AllocationList = ({
  items,
  showSignAllocationModal,
  showConfirmAllocationModal,
  deleteAllocation,
  isFetching,
  pendingActions,
  filter,
  onChange,
  onTurnFilterOff,
  total,
  count,
  minMonths,
  maxMonths,
  interestMin,
  interestMax
}) => {

  const somethingInFilter = filter.type === '' &&
                            filter.status === '' &&
                            filter.createdAt.length === 0 &&
                            filter.interest.length === 0 &&
                            filter.months.length === 0

  const [toggleFilter, setToggleFilter] = useState(!somethingInFilter)


  const toggleFilterState = () => {
    if (toggleFilter) {
      
      onTurnFilterOff()
    }
    setToggleFilter(!toggleFilter)
  }

  return (
    <div>
      <PendingActionAlert pendingActions={pendingActions} />
      <div style={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>   
        <Button onClick={() => toggleFilterState()}><Icon type="filter" /> Filter {!somethingInFilter ? `(Nájdených ${count} z ${total} investícií)` : ""}</Button>
      </div>
      {
          toggleFilter && <div style={{paddingBottom: 30+'px'}}> 
          <AllocationsFilter 
            filter={filter}
            onChange={onChange}
            total={total}
            count={count}
            minMonths={minMonths}
            maxMonths={maxMonths}
            interestMin={interestMin}
            interestMax={interestMax}
          />
          </div>
        }    
      <div className="list-wrapper">
        <SignAllocation />
       
        {items.map(allocation => (
          <AllocationItem
            allocation={allocation}
            key={allocation.id}
            itemOrder={allocation.itemOrder}
            showSignAllocationModal={showSignAllocationModal}
            showConfirmAllocationModal={showConfirmAllocationModal}
            deleteAllocation={deleteAllocation}
          />
        ))}
      </div>
    </div>
  );
}
AllocationList.propTypes = {
  items: PropTypes.array.isRequired,
  showSignAllocationModal: PropTypes.func.isRequired,
  showConfirmAllocationModal: PropTypes.func.isRequired,
  deleteAllocation: PropTypes.func,
  isFetching: PropTypes.bool.isRequired,
  pendingActions: PropTypes.number.isRequired,
};

export default AllocationList;



// WEBPACK FOOTER //
// ./src/features/allocations/components/AllocationList.js